import React from "react";
import { useTranslation } from "react-i18next";
import CalendarV2Icon16pxSvg from "../../../assets/images/icons/CalendarV2Icon16pxSvg";
import ReportIcon20pxSvg from "../../../assets/images/icons/ReportIcon20pxSvg";
import UserIcon20pxSvg from "../../../assets/images/icons/UserIcon20pxSvg";
import EventLogIcon20pxSvg from "../../../assets/images/icons/EventLogIcon20pxSvg";
import ClockSolidIcon16pxSvg from "../../../assets/images/icons/ClockSolidIcon16pxSvg";
import DeviceIcon20pxSvg from "../../../assets/images/icons/DeviceIcon20pxSvg";
import TotalWorkHourReportIcon from "../../../assets/images/icons/TotalWorkHourReportIcon";
import WorkHourSummaryReportIcon from "../../../assets/images/icons/WorkHourSummaryReportIcon";
import ProductivityReportIcon from "../../../assets/images/icons/ProductivityReportIcon";
import UserDetailReportIcon from "../../../assets/images/icons/UserDetailReportIcon";
import UserDetailsReportIcon from "../../../assets/images/icons/UserDetailsReportIcon";
import ArrrivalAndDepartureReportIcon from "../../../assets/images/icons/ArrrivalAndDepartureReportIcon";
import DeviceReportIcon from "../../../assets/images/icons/DeviceReportIcon";
import EventDetailsIcon from "../../../assets/images/icons/EventDetailsIcon";

export const REPORT_ITEMS = [
  {
    id: 0,
    titleKey: "common.total-work-hours-report",
    descKey: "common.total-work-hours-report-desc",
    icon: <TotalWorkHourReportIcon />,
    disabled: false,
    tourId: "reports-total-work-hours-report",
  },
  {
    id: 1,
    titleKey: "common.work-hour-summary-report",
    descKey: "common.work-hour-summary-report-desc",
    icon: <WorkHourSummaryReportIcon />,
    disabled: false,
    tourId: "reports-work-hours-summary-report",
  },
  {
    id: 2,
    titleKey: "common.productivity-report",
    descKey: "common.productivity-report-desc",
    icon: <ProductivityReportIcon />,
    disabled: false,
    tourId: "reports-productivity-report",
  },
  {
    id: 3,
    titleKey: "common.user-details-report",
    descKey: "common.user-details-report-desc",
    icon: <UserDetailReportIcon />,
    disabled: false,
    tourId: "reports-user-details-report",
  },
  {
    id: 4,
    titleKey: "common.event-details-report",
    descKey: "common.event-details-report-desc",
    icon: <EventDetailsIcon />,
    disabled: true,
  },
  {
    id: 5,
    titleKey: "common.arrival-and-departure-report",
    descKey: "common.arrival-and-departure-report-desc",
    icon: <ArrrivalAndDepartureReportIcon />,
    disabled: true,
  },
  {
    id: 6,
    titleKey: "common.devices-report",
    descKey: "common.devices-report-desc",
    icon: <DeviceReportIcon />,
    disabled: true,
  },
];

const ReportsHub = ({ onSelectReport }) => {
  const { t } = useTranslation();

  return (
    <div className="card px-3 py-3">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {REPORT_ITEMS.map((item) => (
          <button
            key={item.id}
            type="button"
            disabled={item.disabled}
            onClick={() => onSelectReport(item.id)}
            data-tour={item.tourId}
            className={`
              text-left rounded-xl border border-[#E5E7EB] bg-white p-2
              transition-all duration-200 flex flex-col items-start justify-start
              ${item.disabled
                ? "opacity-50 cursor-not-allowed"
                : "cursor-pointer hover:border-[#0057FF] hover:shadow-md"
              }
            `}
          >
            <div className="rounded-lg flex items-start justify-start mb-4 [&_svg_path]:fill-[#0057FF]">
              {item.icon}
            </div>

            <h3 className="text-base font-semibold text-[#1F2937] mb-2 leading-snug">
              {t(item.titleKey)}
            </h3>

            <p className="text-sm text-[#6B7280] leading-relaxed">
              {t(item.descKey)}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportsHub;
